export const INITIAL_STATE = {
    buildingNumber:'',
    city:'',
    id:0,
    companyName:'', 
    companyTax: '',
    country:'Polska', 
    email:'',
    flatNumber:'',
    fullStreet:'',
    name:'',
    surname:'',
    newCustomer: false,
    phone:'',
    phoneCode:'',
    postalCode:'',
    street:'',
    type:{
        id:1, 
        displayName: '',
        customerType: '',
        description: '',
        value:''
    }
};


// WEBPACK FOOTER //
// ./src/reducers/state/Customer.js